import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_CARD_USER_CUSTOMIZATION_HANDLER = {
  topic: TOPIC_NAMES.OPEN_CARD_USER_CUSTOMIZATION,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/PropertiesCardUserCustomization')
};